<template>
  <modal :visible.sync='visible' width='500px' :title="guide.id? $t('public.edit_guidance_item'):$t('public.add_guidance_item')">
    <el-form label-width='140px'>
      <el-form-item :label="$t('public.guide_item_name')">
        <el-input class='input' v-model='guide.name'></el-input>
      </el-form-item>
      <el-form-item :label="$t('public.guide_code')">
        <el-input class='input' v-model='guide.code'></el-input>
      </el-form-item>
      <el-form-item :label="$t('public.group')">
        <el-select v-model="guide.guideGroup" class='input'>
          <el-option :value='item.id' :label='item.groupName' :key='item.id' v-for='item,index in groups'></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type='primary' @click='confirm'>{{ $t('integration.confirm') }}</el-button>
      <el-button @click='close'>{{ $t('public.btn_close') }}</el-button>
    </template>
  </modal>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    // 引导项列表
    guideItem: {
      type: Object
    },
    groups: {
      type: Array
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (val) {
        return this.$emit('update:show', val)
      }
    }
  },
  watch: {
    guideItem (val) {
      this.guide = { ...val }
    }
  },
  data () {
    return {
      // 内部的引导项
      guide: {}
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    confirm () {
      this.$emit('confirm', this.guide)
      this.close()
    }
  }
}
</script>

<style scoped lang='scss'>
.input {
  width: 250px;
}

</style>
